<template>
  <component :is="icon" class="ui-document-icon" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { DocumentSource } from '@types'

import GoogleDriveIcon from '@/assets/images/services/document-google-drive.svg'
import DropboxIcon from '@/assets/images/services/document-dropbox.svg'
import OneDriveIcon from '@/assets/images/services/document-onedrive.svg'
import UrlIcon from '@/assets/images/services/document-url.svg'
import AllpositIcon from '@/assets/images/services/document-allposit.svg'
import AllpositThumbIcon from '@/assets/images/services/document-allposit-thumb.svg'

const images = {
  [DocumentSource.GOOGLE_DRIVE]: GoogleDriveIcon,
  [DocumentSource.DROPBOX]: DropboxIcon,
  [DocumentSource.ONE_DRIVE]: OneDriveIcon,
  [DocumentSource.URL]: UrlIcon,
  [DocumentSource.ALLPOSIT]: AllpositIcon,
  [DocumentSource.ALLPOSIT_THUMBNAIL]: AllpositThumbIcon,
}

type Props = {
  source: DocumentSource
}

const { source } = defineProps<Props>()

const icon = computed(
  () => images[source] || null,
)
</script>

<style>
.ui-document-icon {
  @apply w-3 h-3;
}
</style>
